module.exports = __webpack_public_path__ + "static/media/HCMM075.423f2cbe.jpg";